enum UniverseSort {
  GameName = 'GameName',
  GameCreated = 'GameCreated',
  LastUpdated = 'LastUpdated',

  /**
   * Including these for reference, but not including as options as there is no
   * product reason for them, and LastUpdated only supports one sortorder.
   */
  // RootPlaceName = 'RootPlaceName',
  // RootPlaceUpdated = 'RootPlaceUpdated',
}

export default UniverseSort;
